"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataChange = DataChange;
exports["default"] = withDataChange;
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
function DataChange(props) {
  var Component = props.Component;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  function dataChangeSubscribe(handler) {
    return context.res.wappResponse.store.subscribe(function (_ref) {
      var type = _ref.type,
        payload = _ref.payload;
      if (type === 'INS_APP' && payload.name === 'data') {
        handler(payload);
      }
    });
  }
  function useDataChange(handler) {
    (0, _react.useEffect)(function () {
      return dataChangeSubscribe(handler);
    });
  }
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, props, {
    dataChangeSubscribe: dataChangeSubscribe,
    useDataChange: useDataChange
  }));
}
function withDataChange(Component) {
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(DataChange, Object.assign({}, props, {
      ref: ref,
      Component: Component
    }));
  });
}